import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { MdbModalModule, MdbModalService } from 'src/lib/mdb5-adapted/public-api';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, Observable, Subject, takeUntil } from 'rxjs';
import { LoadSpinnerService } from './loadspinner.service';

interface SpinnerAttr {
  message: string | null;
  showTimer: number;
  loading: boolean;
}

@Component({
  selector: 'app-lmsspinner',
  templateUrl: 'spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [MdbModalService],
  imports: [CommonModule, MdbModalModule],
})
export class SpinnerComponent implements OnInit, OnDestroy {
  private spinnerService = inject(LoadSpinnerService);
  showTimer: number = 1;

  message: string | null;
  private destroy$ = new Subject<void>();
  public showClock$ = new BehaviorSubject<number>(this.showTimer);
  display = '03:00';

  readonly loadSpinner$: Observable<SpinnerAttr> = combineLatest([
    this.spinnerService.message$,
    this.spinnerService.showspinner$,
    this.spinnerService.loading$
  ]).pipe(
    map(([message, showTimer, loading]) => ({ message, showTimer, loading })),
    takeUntil(this.destroy$),
    distinctUntilChanged((a, b) =>
      a.message === b.message &&
      a.showTimer === b.showTimer &&
      a.loading === b.loading
    )
  );

  public constructor() { }
  ngOnInit(): void {
    // this.loaderService.isLoading.subscribe((v) => {
    //   console.log(v);
    //   this.loading = v;
    // });
    this.timer(3);
  }

  timer(minute: any) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec = 60;
    const prefix = minute < 10 ? '0' : '';

    const inter = setInterval(() => {
      seconds--;
      if (statSec != 0) {
        statSec--;
      } else {
        statSec = 59;
      }

      if (statSec < 10) {
        textSec = `0${statSec}`;
      } else {
        textSec = statSec;
      }

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
       clearInterval(inter);
      }
    }, 1000);
  }

  public setNewDataMessage(message?: string) {
    this.message = message == '' || message == undefined ? 'Please wait!!' : message;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
